import { useContext } from 'react';
import { BREAKPOINTS_WIDTHS, useWindowSize } from '@belong/common';
import { Button, Money, Text } from '@belong/ui';
import { ApprovalContext } from 'pages/PostInspectionFlow/steps/Improvements/Approval/ApprovalContext';
import { STRINGS } from 'post-inspection/constants/strings';

type Props = {
  onNextStepClick: () => void;
};

export const PaymentSummaryFooter = ({ onNextStepClick }: Props) => {
  const { homeownerReportPayment, inspectionType } =
    useContext<any>(ApprovalContext);
  const { isPreMoveOut } = inspectionType;

  const { width } = useWindowSize();

  const _isMobile = width < BREAKPOINTS_WIDTHS.SM;

  const { groupDueNow } = homeownerReportPayment;

  const handleClick = () => {
    onNextStepClick();
  };

  let cta = groupDueNow ? STRINGS['approve-pay-deposit'] : STRINGS.approve;
  if (isPreMoveOut) {
    cta = STRINGS['approve-pay-deposit.pre_move_out'];
  }

  return (
    <div
      className="
        fixed -left-2sm bottom-0 left-0 flex w-screen flex-col items-center justify-between bg-dark-navy px-sm py-md md:relative md:left-0 md:w-full md:flex-row md:rounded-b-small md:py-lg
      "
    >
      <div className="hidden items-center justify-end self-end md:flex">
        <Button onClick={handleClick} size="auto">
          <div className="px-sm">{cta}</div>
        </Button>
      </div>
      {!isPreMoveOut && (
        <div className="mb-sm flex items-end md:mb-0 md:flex-col md:justify-start">
          <Text as="span" className="mr-[6px] text-white md:mr-0">
            {STRINGS['due-upfront']}
          </Text>
          <Money
            as="span"
            className="text-white"
            fontWeight="semibold"
            format="DOLLARS_WITH_CENTS"
            value={groupDueNow}
            variant="h3"
          />
        </div>
      )}
      <div className="flex w-full items-center md:hidden">
        <Button onClick={handleClick} size="fluid">
          <div className="px-sm">{cta}</div>
        </Button>
      </div>
    </div>
  );
};
